import * as Factory from 'factory.ts'
import faker from 'faker'

import { type SsoConnection } from '../../models'

export const SsoConnectionMock = Factory.Sync.makeFactory<SsoConnection>({
  provider: 'azure-oidc',
  discovery_url: Factory.each(() => faker.internet.url()),
  client_id: Factory.each(() => faker.random.uuid()),
})
